import React from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar } from 'lucide-react';

interface ExpirationSelectorProps {
  expiresInDays: number;
  onChange: (days: number) => void;
}

export default function ExpirationSelector({ expiresInDays, onChange }: ExpirationSelectorProps) {
  const { t } = useTranslation('createNote');

  return (
    <label className="block text-sm font-medium text-gray-700">
      <div className="flex items-center mb-2">
        <Calendar className="w-5 h-5 mr-2" />
        <span>{t('form.expiration.label')}</span>
      </div>
      <div className="flex items-center justify-between gap-4">
        <input
          type="range"
          value={expiresInDays}
          onChange={(e) => onChange(Number(e.target.value))}
          min={1}
          max={30}
          className="flex-grow h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-blue-500"
        />
        <div className="shrink-0 min-w-[5.5rem] text-center font-medium text-gray-700 bg-gray-100 px-3 py-1.5 rounded-lg">
          {t('form.expiration.value', { count: expiresInDays })}
        </div>
      </div>
      <p className="text-xs text-gray-500 mt-1">
        {t('form.expiration.hint')}
      </p>
    </label>
  );
}